export default function maskPhone(phone: string) {
  return (phone = '(' + phone.slice(3, 5) + ') ' + phone.slice(5, 10) + '-' + phone.slice(10, 14))
}
